import { ProductPriceSchedule } from '../../booking/models/product-price-schedule';

export class Product {
  constructor(
    public id: number,
    public name: string,
    public price: number,
    public taxRate: number,
    public iconUrl: string = '',
    public description: string = '',
    public productPriceSchedules: ProductPriceSchedule[] = [],
    public sequence: number = 1,
    public isAreaItem: boolean = false,
    public quantityMin: number = 0,
    public quantityMax: number = 0,
    public groupSizeMin: number = 0,
    public groupSizeMax: number = 0,
    public isPinRequired: boolean = false,
    public saleDescription: string = '',
    public categoryId?: number,
    public categoryName?: string,
    public productTemplateId?: number,
    public attributes?: {}
  ) { }

  static createFromAny(data: any): Product {
    if (data === null || data === undefined) {
      return null;
    }

    return new Product(
      data.id,
      data.name,
      data.price,
      data.taxRate ? data.taxRate : 0,
      data.iconUrl,
      data.description,
      data.productPriceSchedules ? data.productPriceSchedules.map(x => ProductPriceSchedule.createFromAny(x)) : null,
      data.sequence,
      data.isAreaItem,
      data.quantityMin,
      data.quantityMax,
      data.groupSizeMin,
      data.groupSizeMax,
      data.isPinRequired,
      data.saleDescription,
      data.categoryId,
      data.categoryName,
      data.productTemplateId,
      data.attributes,
    );
  }

  getProductImageUrl(): string {
    if (this.iconUrl) {
      return this.iconUrl;
    } else if (this.id != null) {
      return `/store/product_image/${this.id}` + '?type=webshop_product_image';
    }
    return '';
  }

  get isGroupBooking(): boolean {
    return this.groupSizeMin > 0 || this.groupSizeMax > 0;
  }

}
